var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_587_49705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 2.5C15.6377 2.49996 16.2513 2.7436 16.7152 3.18107C17.1792 3.61854 17.4584 4.21676 17.4958 4.85333L17.5 5V15C17.5 15.6377 17.2564 16.2513 16.8189 16.7152C16.3815 17.1792 15.7832 17.4584 15.1467 17.4958L15 17.5H5C4.36232 17.5 3.74874 17.2564 3.28478 16.8189C2.82083 16.3815 2.54158 15.7832 2.50417 15.1467L2.5 15V5C2.49996 4.36232 2.7436 3.74874 3.18107 3.28478C3.61854 2.82083 4.21676 2.54158 4.85333 2.50417L5 2.5H15ZM15 4.16667H7.5V15.8333H15C15.2041 15.8333 15.4011 15.7584 15.5536 15.6227C15.7062 15.4871 15.8036 15.3002 15.8275 15.0975L15.8333 15V5C15.8333 4.79589 15.7584 4.59889 15.6227 4.44636C15.4871 4.29383 15.3002 4.19638 15.0975 4.1725L15 4.16667ZM13.0892 7.74417C13.2326 7.88766 13.3188 8.07858 13.3316 8.2811C13.3443 8.48362 13.2827 8.68383 13.1583 8.84417L13.0892 8.9225L12.0125 10L13.0892 11.0775C13.2326 11.221 13.3188 11.4119 13.3316 11.6144C13.3443 11.817 13.2827 12.0172 13.1583 12.1775L13.0892 12.2558C12.9457 12.3993 12.7548 12.4855 12.5522 12.4982C12.3497 12.511 12.1495 12.4494 11.9892 12.325L11.9108 12.2558L10.2442 10.5892C10.1007 10.4457 10.0145 10.2548 10.0018 10.0522C9.98903 9.84971 10.0506 9.6495 10.175 9.48917L10.2442 9.41083L11.9108 7.74417C12.0671 7.58794 12.279 7.50018 12.5 7.50018C12.721 7.50018 12.9329 7.58794 13.0892 7.74417Z",
    fill: "#8FA1A7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_587_49705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutBtn);
export default __webpack_public_path__ + "static/media/logout-btn.84f5c2603474a3777b518d342bf09b87.svg";
export { ForwardRef as ReactComponent };